<template>
     <!-- 视频 -->
    <div class="videoDiv" v-if="videoShow">
      <div class="closeIcon" @click="closeVideoShow()"><span class="el-icon-close"></span></div>
      <div @click="$event.preventDefault();" class="contentPart">
        <video :src="videoUrl" id="videoId" @click="videoClick()" autoplay controls="controls" controlsList="nodownload" style="width:100%;height:100%;object-fit: fill;border-radius: 8px;" ></video>
      </div>
    </div>
</template>
 
<script>
export default {
   name: "videoCommon",
    props:["videoTitle","videoUrl"],
    components:{
    },
    data() {
        return {
            videoShow:false,
            playIconShow:false,
            pauseIconShow:false,
        };
    },
    created(){

    },
    methods:{
        openVideoShow(){
           this.videoShow = true;
        },
        closeVideoShow(){
            this.videoShow = false;
        },
        videoClick(){
            var videoId = document.getElementById("videoId");
            if(videoId.paused){
                this.pauseIconShow = false;
                this.playIconShow = true;
                setTimeout(()=>{
                      this.playIconShow = false;
                },500);
            }else{ 
                this.pauseIconShow = true;
                // setTimeout(()=>{
                //       this.pauseIconShow = ! this.pauseIconShow;
                // },1000);
            }
        },

        // changemjh(data){
        //      this.$emit('cqqclick',data);
        // }

    },
     mounted() {
        //   this.videoClick();
        //   document.getElementById('videoId').currentTime = 0;
     },
}
</script>

<style scoped lang="less">
    .videoDiv{
        position:fixed;
        top:0;
        left:0;
        width:100%;
        height:100%;
        background: rgba(0,0,0,0.8);
        z-index:9999;
        .closeIcon{
            position:absolute;
            top:50px;
            right:50px;
            color: #ffffff;
            cursor: pointer;
            span{
                font-size: 22px;
            }
        }
        .contentPart{
            width: 1080px;
            height: 608px;
            background: #000;
            position: absolute;
            top:50%;
            left:50%;
            margin-left:-540px;
            margin-top:-304px;
            .videoTitle{
                font-size:20px;
                // color: #000;
                color: #fff;
                position: absolute;
                top:16px;
                left:16px;
            }
            .pauseIcon{
                position: absolute;
                color: #ffffff;
                top:50%;
                left: 50%;
                margin-left:-40px;
                margin-top:-40px;
                span{
                    font-size:80px;
                }
            }
            .playIcon{
                position: absolute;
                color: #ffffff;
                top:50%;
                left: 50%;
                margin-left:-40px;
                margin-top:-40px;
                span{
                    font-size:80px;
                }
            }
        }
    }
    
</style>



// WEBPACK FOOTER //
// src/components/videoCommon.vue